module.exports = __webpack_public_path__ + "media/bootstrap-icons/card-checklist-9137e9c0.svg";